var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmexcard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.18747 4.92273H32.8125C34.02 4.92273 35 5.90268 35 7.11128V27.8925C35 29.1001 34.02 30.08 32.8125 30.08H2.18747C0.978873 30.0801 0 29.1001 0 27.8927V7.11128C0 5.90268 0.979953 4.92273 2.18747 4.92273Z",
    fill: "#26A6D1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.64378 13.6724L2.1875 21.321H6.32516L6.83811 20.1015H8.01059L8.52354 21.321H13.0779V20.3902L13.4838 21.321H15.8397L16.2455 20.3706V21.321H25.7174L26.8691 20.1332L27.9476 21.321L32.8125 21.3308L29.3453 17.518L32.8125 13.6724H28.023L26.9019 14.8383L25.8574 13.6724H15.5532L14.6684 15.6465L13.7628 13.6724H9.63377V14.5715L9.17444 13.6724C9.17444 13.6724 5.64378 13.6724 5.64378 13.6724ZM6.4444 14.7585H8.46128L10.7538 19.9451V14.7585H12.9633L14.734 18.4772L16.3659 14.7585H18.5643V20.2469H17.2266L17.2157 15.9462L15.2655 20.2469H14.0689L12.1078 15.9462V20.2469H9.35594L8.83424 19.0165H6.01566L5.49503 20.2458H4.02061L6.4444 14.7585ZM19.7881 14.7585H25.2274L26.891 16.5555L28.6082 14.7585H30.2718L27.7441 17.517L30.2718 20.2436H28.5327L26.8691 18.4258L25.1431 20.2436H19.7881V14.7585ZM7.42555 15.6871L6.49694 17.879H8.35308L7.42555 15.6871ZM21.1313 15.8949V16.8968H24.0987V18.0135H21.1313V19.1073H24.4596L26.0061 17.4962L24.5252 15.8939H21.1313V15.8949Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmexcard);
export default __webpack_public_path__ + "static/media/amexcard.5dee5ff2.svg";
export { ForwardRef as ReactComponent };